export default __webpack_public_path__ + "static/opinion-1-d2074fea035dd4d8a3a221bf4d1a476e.jpg";